module.exports = __webpack_public_path__ + "static/media/CashAppBankingHero.5b50b155.jpg";